var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", [
      _c(
        "div",
        { staticClass: "form-group m-form__group row m--margin-top-10" },
        [
          _c(
            "label",
            {
              staticClass: "col-3 col-form-label",
              attrs: { for: "photographer" }
            },
            [_vm._v("\n                Fotograf\n            ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-9" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.project.photographer_user_id,
                    expression: "project.photographer_user_id"
                  }
                ],
                staticClass: "form-control m-input",
                attrs: { id: "photographer" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.project,
                        "photographer_user_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    function($event) {
                      _vm.dataChange = true
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "0" } }, [
                  _vm._v("Mitarbeiter wählen")
                ]),
                _vm._v(" "),
                _vm._l(_vm.photographerArr, function(photoprapher, key) {
                  return _c("option", { domProps: { value: key } }, [
                    _vm._v(_vm._s(photoprapher))
                  ])
                })
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group m-form__group row m--margin-top-10" },
        [
          _c(
            "label",
            {
              staticClass: "col-3 col-form-label",
              attrs: { for: "manageruserid" }
            },
            [_vm._v("\n                Projektmanager\n            ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-9" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.project.manager_user_id,
                    expression: "project.manager_user_id"
                  }
                ],
                staticClass: "form-control m-input",
                attrs: { id: "manageruserid" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.project,
                        "manager_user_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    function($event) {
                      _vm.dataChange = true
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "0" } }, [
                  _vm._v("Mitarbeiter wählen")
                ]),
                _vm._v(" "),
                _vm._l(_vm.photographerArr, function(photoprapher, key) {
                  return _c("option", { domProps: { value: key } }, [
                    _vm._v(_vm._s(photoprapher))
                  ])
                })
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group m-form__group row m--margin-top-10" },
        [
          _c(
            "label",
            { staticClass: "col-3 col-form-label", attrs: { for: "kw" } },
            [_vm._v("\n                Kalenderwoche Fotografie\n            ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-9" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.project.kw,
                    expression: "project.kw"
                  }
                ],
                staticClass: "form-control m-input",
                attrs: { id: "kw" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.project,
                        "kw",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    function($event) {
                      _vm.dataChange = true
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "0" } }, [
                  _vm._v("Kalenderwoche wählen")
                ]),
                _vm._v(" "),
                _vm._l(_vm.kwPlanning, function(kw) {
                  return _c("option", { domProps: { value: kw.date } }, [
                    _vm._v(
                      _vm._s(kw.title) + " - " + _vm._s(kw.count) + " Projekte"
                    )
                  ])
                })
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group m-form__group row m--margin-top-10" },
        [
          _c(
            "label",
            { staticClass: "col-3 col-form-label", attrs: { for: "prio" } },
            [_vm._v("\n                Priorität\n            ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-9" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.project.current_priority_id,
                    expression: "project.current_priority_id"
                  }
                ],
                staticClass: "form-control m-input",
                attrs: { id: "prio" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.project,
                        "current_priority_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    function($event) {
                      _vm.dataChange = true
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "0" } }, [
                  _vm._v("Kalenderwoche wählen")
                ]),
                _vm._v(" "),
                _vm._l(_vm.prioArr, function(prio, key) {
                  return _c("option", { domProps: { value: key } }, [
                    _vm._v(_vm._s(prio))
                  ])
                })
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group m-form__group row m--margin-top-10" },
        [
          _c(
            "label",
            {
              staticClass: "col-3 col-form-label",
              attrs: { for: "serviceprovider" }
            },
            [_vm._v("\n                Dienstleister\n            ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-9" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.project.service_provider_id,
                    expression: "project.service_provider_id"
                  }
                ],
                staticClass: "form-control m-input",
                attrs: { id: "serviceprovider" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.project,
                        "service_provider_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    function($event) {
                      _vm.dataChange = true
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "0" } }, [
                  _vm._v("Dienstleister wählen")
                ]),
                _vm._v(" "),
                _vm._l(_vm.serviceProviders, function(serviceProvider) {
                  return _c(
                    "option",
                    { domProps: { value: serviceProvider.id } },
                    [_vm._v(_vm._s(serviceProvider.name))]
                  )
                })
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-right" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-success",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.updateProject()
              }
            }
          },
          [_vm._v("speichern")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }